export function sendPageview(pageTitle) {
    const path = `${window.location.pathname}/${pageTitle.toLowerCase()}`;

    if (typeof ga !== 'undefined') {
        ga('gifted.send', {
            hitType: 'pageview',
            page: path,
            title: `Checkout - ${pageTitle}`,
        });

        if (window.Gifted?.hotelGaTracker) {
            ga(window.Gifted.hotelGaTracker + '.send', {
                hitType: 'pageview',
                page: path,
                title: `Checkout - ${pageTitle}`,
            });
        }
    }

    if (typeof gtag !== 'undefined') {
        gtag('event', 'page_view', {
            page_location: window.location.origin + path,
            page_title: `${pageTitle} - ${document.title}`,
        });
    }
}

export function sendEvent(category, action, label) {
    if (typeof ga !== 'undefined') {
        ga('gifted.send', 'event', category, action, label);
    }
}

export function sendEcommerceEvent(type, basket, extraParams = {}) {
    if (typeof gtag === 'undefined') {
        return;
    }

    const params = {
        currency: basket.currency,
        items: basket.itemsGA4,
        value: basket.total,
    };

    if (type === 'add_to_cart' || type === 'remove_from_cart') {
        if (!basket.lastItem) {
            return;
        }

        params.items = [{ ...basket.lastItem, quantity: 1 }];
        params.value = basket.lastItem.price;
    }

    gtag('event', type, Object.assign(params, extraParams));
}
